import { formatDate } from '../common/formatDate';
import { DATE_FORMAT_LONG_FNS } from '../constants/dateFormats';

export function makeDateNotExcludedValidator<T>(
  errorMsg: T,
  getExcludedDates: () => string[] | undefined,
  valueParseFormat?: string,
  dateFormat: string = DATE_FORMAT_LONG_FNS,
) {
  return (value: string) => {
    const excludedDates = getExcludedDates();

    if (!excludedDates?.length || !value) {
      return undefined;
    }

    const formattedValue = formatDate({
      date: value,
      dateFormat,
      parseFormat: valueParseFormat,
    });

    const isExcluded = excludedDates.some(excludedDate => {
      const formattedExcluded = formatDate({
        date: excludedDate,
        dateFormat,
      });

      return formattedExcluded === formattedValue;
    });

    return isExcluded ? errorMsg : undefined;
  };
}
